export default __webpack_public_path__ + "static/mintContainerBg-b099ac56aa5e29e80d41a734ad8ecf45.png";